const items = [-1, 25, 100, 250];

// eslint-disable-next-line import/prefer-default-export
export { items as itemsPerPage };
